"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var popover_1 = require("./popover");
var popover_config_1 = require("./popover-config");
var popover_2 = require("./popover");
exports.NgbPopover = popover_2.NgbPopover;
var popover_config_2 = require("./popover-config");
exports.NgbPopoverConfig = popover_config_2.NgbPopoverConfig;
var NgbPopoverModule = (function () {
    function NgbPopoverModule() {
    }
    NgbPopoverModule_1 = NgbPopoverModule;
    NgbPopoverModule.forRoot = function () { return { ngModule: NgbPopoverModule_1, providers: [popover_config_1.NgbPopoverConfig] }; };
    NgbPopoverModule = NgbPopoverModule_1 = __decorate([
        core_1.NgModule({ declarations: [popover_1.NgbPopover, popover_1.NgbPopoverWindow], exports: [popover_1.NgbPopover], entryComponents: [popover_1.NgbPopoverWindow] })
    ], NgbPopoverModule);
    return NgbPopoverModule;
    var NgbPopoverModule_1;
}());
exports.NgbPopoverModule = NgbPopoverModule;
//# sourceMappingURL=popover.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/popover/popover.module.js
// module id = 60
// module chunks = 0